import { getFullDate } from '../PublishSendSessionModal';

export const templateFilial = (dataSession) => {
	const mailTemplateFilialConsejoAdmin =
		`<div style="text-align:justify;">
				<p><strong>#usuario#,</strong></p>
				<br>
				<p>Con fundamento en los artículos 3, fracción V y último párrafo, y quinto Transitorio, de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, así como en lo dispuesto en los artículos Vigésimo Tercero y Vigésimo Séptimo, numerales 3 y 5, de los Estatutos de la persona moral “INFONAVIT CONSTRUCTORA, S.A. de C.V.”, contenidos en la Escritura Pública número 81,910, de fecha 19 de marzo de 2025, pasada ante la fe del Lic. Sergio Navarrete Mardueño, Titular de la Notaría Pública Número 128 de la Ciudad de México, se convoca a usted a la sesión <strong> ` +
		dataSession.numero_sesion +
		`</strong> del <strong>` +
		dataSession.nameOrgan +
		`</strong>, la cual se llevará a cabo el ` +
		`<strong>${getFullDate(dataSession.fhora)}</strong>` +
		`, vía remota, con el siguiente:</strong> </p>	<br>
				<br>
				<b>Atentamente</b>
				<br>
				<br>
				<strong>Marcos M. Herrería Alamina</strong>
				<br>
				<strong>Consejero Secretario</strong>
				</div>
				`;

	const mailTemplateFilial =
		`<div style="text-align:justify;">
				<p><strong>#usuario#,</strong></p>
				<br>
				<p>Con fundamento en los artículos 3, fracción V y último párrafo, y quinto Transitorio, de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, así como en lo dispuesto en los artículos Vigésimo Tercero y Vigésimo Séptimo, numerales 3 y 5, de los Estatutos de la persona moral “INFONAVIT CONSTRUCTORA, S.A. de C.V.”, contenidos en la Escritura Pública número 81,910, de fecha 19 de marzo de 2025, pasada ante la fe del Lic. Sergio Navarrete Mardueño, Titular de la Notaría Pública Número 128 de la Ciudad de México, se convoca a usted a la sesión <strong> ` +
		dataSession.numero_sesion +
		`</strong> del <strong>` +
		dataSession.nameOrgan +
		`</strong>, la cual se llevará a cabo el ` +
		`<strong>${getFullDate(dataSession.fhora)}</strong>` +
		`, vía remota, con el siguiente:</strong> </p>	<br>
				<br>
				<b>Atentamente</b>
				<br>
				<br>
				<strong>Mayra Chim Kantún</strong>
				<br>
				<strong>Secretaria</strong></strong>
				</div>
				`;

	return dataSession.nameOrgan === 'Consejo de Administración'
		? mailTemplateFilialConsejoAdmin
		: mailTemplateFilial;
};
